import { render, staticRenderFns } from "./Desking.vue?vue&type=template&id=3705d084&scoped=true"
import script from "./Desking.vue?vue&type=script&lang=js"
export * from "./Desking.vue?vue&type=script&lang=js"
import style0 from "./Desking.vue?vue&type=style&index=0&id=3705d084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3705d084",
  null
  
)

export default component.exports